<div>
  <select [formControl]="inputControl"
    class="form-control">
    @for (language of availableLanguages; track language) {
      <option [value]="language.value">{{ language.label }}</option>
    }
  </select>
</div>
